import React from 'react';
import PropTypes from 'prop-types';

/**
 * Columns - A simple HTML replacement for Bloomer's Columns component
 * Uses the same class names as Bloomer for perfect CSS compatibility
 */
export function Columns({
  isMultiline = false,
  isCentered = false,
  isGapless = false,
  isVCentered = false,
  isMobile = false,
  isDesktop = false,
  className = '',
  children = null,
  ...rest
}) {
  // Build the class name string based on props
  let classNames = 'columns';
  
  if (isMultiline) {
    classNames += ' is-multiline';
  }
  if (isCentered) {
    classNames += ' is-centered';
  }
  if (isGapless) {
    classNames += ' is-gapless';
  }
  if (isVCentered) {
    classNames += ' is-vcentered';
  }
  if (isMobile) {
    classNames += ' is-mobile';
  }
  if (isDesktop) {
    classNames += ' is-desktop';
  }
  
  if (className) {
    classNames += ` ${className}`;
  }

  // Remove custom props that shouldn't be forwarded to the DOM
  const {
    isMultiline: _im,
    isCentered: _ic,
    isGapless: _ig,
    isVCentered: _ivc,
    isMobile: _imob,
    isDesktop: _idesk,
    ...domProps
  } = { ...rest, isMultiline, isCentered, isGapless, isVCentered, isMobile, isDesktop };

  return (
    <div className={classNames} {...domProps}>
      {children}
    </div>
  );
}

// eslint-disable-next-line react/require-default-props
Columns.propTypes = {
  isMultiline: PropTypes.bool,
  isCentered: PropTypes.bool,
  isGapless: PropTypes.bool,
  isMobile: PropTypes.bool,
  isDesktop: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node,
};

export default Columns;
